<template>
    <div class="month-picker">
        <div class="modal" @click="bodyOpened = false" v-if="bodyOpened"></div>
        <div :class="pickerClass" @click="openBody">
            {{ dateDisplay }}
        </div>
        <transition name="fade" mode="out-in">
            <div class="select-body" v-if="bodyOpened">
                <div class="select-year">
                    <div class="arrow" @click="changeYear('left')">
                        <i class="material-icons">{{ 'chevron_left' }}</i>
                    </div>
                    <div class="year">{{ year }}</div>
                    <div class="arrow" @click="changeYear('right')">
                        <i class="material-icons">{{ 'chevron_right' }}</i>
                    </div>
                </div>
                <div class="select-month">
                    <table>
                        <tr>
                            <th @click="selectDate('01')">
                                {{ $t('LABEL_SHORT_JAN') }}
                            </th>
                            <th @click="selectDate('02')">
                                {{ $t('LABEL_SHORT_FEB') }}
                            </th>
                            <th @click="selectDate('03')">
                                {{ $t('LABEL_SHORT_MAR') }}
                            </th>
                            <th @click="selectDate('04')">
                                {{ $t('LABEL_SHORT_APR') }}
                            </th>
                        </tr>
                        <tr>
                            <th @click="selectDate('05')">
                                {{ $t('LABEL_SHORT_MAY') }}
                            </th>
                            <th @click="selectDate('06')">
                                {{ $t('LABEL_SHORT_JUN') }}
                            </th>
                            <th @click="selectDate('07')">
                                {{ $t('LABEL_SHORT_JUL') }}
                            </th>
                            <th @click="selectDate('08')">
                                {{ $t('LABEL_SHORT_AUG') }}
                            </th>
                        </tr>
                        <tr>
                            <th @click="selectDate('09')">
                                {{ $t('LABEL_SHORT_SEP') }}
                            </th>
                            <th @click="selectDate('10')">
                                {{ $t('LABEL_SHORT_OCT') }}
                            </th>
                            <th @click="selectDate('11')">
                                {{ $t('LABEL_SHORT_NOV') }}
                            </th>
                            <th @click="selectDate('12')">
                                {{ $t('LABEL_SHORT_DEC') }}
                            </th>
                        </tr>
                    </table>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    props: {
        alert: Boolean,
        value: String,
        section: Boolean
    },
    data() {
        return {
            selectedDate: '',
            bodyOpened: false,
            year: '',
            selectedMonth: '',
            alerted: false
        }
    },
    computed: {
        pickerClass() {
            return this.section ? 'section-select' : 'select'
        },
        dateDisplay() {
            return this.$moment(this.selectedDate).format('MMMM YYYY')
        }
    },
    methods: {
        openBody() {
            if (this.alert) {
                if (!confirm(this.$t('ALERT_BILLS_MONTH_RELOAD'))) {
                    return
                }
            }
            this.bodyOpened = !this.bodyOpened
        },
        setYear() {
            const year = this.value ? this.$moment(this.value) : this.$moment()
            this.year = parseInt(this.$moment(year).format('YYYY'))
        },
        setDate() {
            let date = new Date()
            if (this.value) {
                this.selectedDate = this.value
            } else {
                this.selectedDate = this.$moment(date).format('YYYY-MM')
            }
        },
        changeYear(direction) {
            if (direction === 'left') {
                this.year = this.year - 1
            }
            if (direction === 'right') {
                this.year = this.year + 1
            }
        },
        selectDate(month) {
            this.selectedDate = this.year + '-' + month
            this.bodyOpened = false
            this.$emit('input', this.selectedDate)
        }
    },
    watch: {
        value() {
            this.setDate()
            this.setYear()
        }
    },
    mounted() {
        this.setDate()
        this.setYear()
    }
}
</script>
<style lang="scss" scoped>
.select {
    display: flex;
    align-items: center;
    justify-content: center;
    border: $input-border;
    padding: 0.4rem 0.5rem;
    box-sizing: border-box;
    border-radius: $small-radius;
    min-height: 2.5rem;
    min-width: 10rem;
    font-size: 0.9rem;
    font-family: $input-family;
    margin-left: 1rem;
    cursor: pointer;
    transition: $ease;
    user-select: none;

    &:hover {
        border-color: $main-accent;
    }
}
.section-select {
    display: flex;
    align-items: center;
    padding: 0.4rem 0.5rem;
    box-sizing: border-box;
    font-family: $input-family;
    cursor: pointer;
    user-select: none;
}
.modal {
    position: fixed;
    z-index: 20;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(68, 68, 68, 0);
}

.select-body {
    position: absolute;
    z-index: 100;
    background: #fff;
    box-shadow: $minimal-shadow;
    border-radius: $minimal-radius;
    padding: 1rem;
    overflow-y: auto;
    font-size: 1rem;
}

.select-year {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.arrow i {
    cursor: pointer;
    transition: $ease;
    font-size: 1.5rem;

    &:hover {
        transform: translateY(0.1rem);
    }
}
.year {
    font-family: $input-family;
    font-size: 20px;
    padding: 0 15px 5px 15px;
}
table tr th {
    padding: 10px;
    cursor: pointer;
    transition: 0.3s all ease;

    &:hover {
        transform: translateY(2px);
    }
}
.fade-enter-active,
.fade-leave-active {
    transition-duration: 0.2s;
    transition-property: opacity;
    transition-timing-function: ease;
}
.fade-enter,
.fade-leave-active {
    opacity: 0;
}
@media (max-width: 1000px) {
    .select-body {
        margin-left: -5%;
    }
}
</style>
